<template>
  <div class="hpanel" id="dataVisualisationPanel">
    <div class="panel-heading" @click="showHide" style="cursor: pointer">
      Data visualisation
      <div class="pull-right text-right">
        <button type="button" class="btn btn-info btn-outline btn-xs showhide">
          <i class="fa fa-chevron-up"></i>
        </button>
      </div>
    </div>
    <div class="panel-body">
      <div style="padding: 0 10px" class="stats">
        <carousel v-if="searchState === 2 && boxOpen === true" :perPage="listType === 'news' ? 1: 2" :perPageCustom="listType === 'news' ? [[0, 1], [1200, 1]] : [[0, 1], [1200, 2]]"
                  :navigationEnabled="true" :loop="true" :paginationActiveColor="'#3498db'" :paginationPosition="'bottom-overlay'">
          <slide>
            <div style="padding: 0 10px">
              <div class="text-muted font-bold m-b-xs underline">
                <u v-if="listType !== 'news'">Suggestions</u>
                <u v-else>Trends</u>
              </div>
              <div style="position: relative">
                <foam-tree-simple-suggestions-box ref="foam" :height="350" :suggestions="suggestions"
                                                  :biblio="biblio" :showLimitPlan="showLimitPlan"></foam-tree-simple-suggestions-box>
<!--                <foam-tree-suggestions-box v-else ref="foam" :height="350" :suggestions="suggestions" :biblio="biblio"></foam-tree-suggestions-box>-->
              </div>
            </div>
          </slide>
          <template v-if="listType !== 'news'">
            <slide>
              <div style="padding: 0 10px">
                <div style="position: relative">
                  <div class="text-muted font-bold m-b-xs">
                    <u>Documents by date</u>
                  </div>
                  <document-by-date ref="documentByDate" :height="350" :pubDate="pubDate"/>
                </div>
              </div>
            </slide>
            <slide>
              <div style="padding: 0 10px">
                <div class="text-muted font-bold m-b-xs">
                  <u>Geo-Location</u>
                </div>
                <maps-by-affiliation ref="geoMaps" :height="350" :countries="countries" :companies="companies"/>
              </div>
            </slide>
            <slide>
              <div style="padding: 0 10px">
                <div style="position: relative">
                  <div class="text-muted font-bold m-b-xs">
                    <span class="label label-warning"> <i>Beta</i></span> <u>Top 5 Companies vs Top 5 Universities</u>
                  </div>
                  <top-affiliations ref="topAffiliations" :height="350" :affiliations="companies" :blurry="$user.isBasic()"/>
                </div>
              </div>
            </slide>
          </template>
        </carousel>
        <div v-else>
          <div class="text-center">
            View your search results in graphical form
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>

  .geoLocation.fullScreen {
    display: block;
    z-index: 1002;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0;
    overflow: hidden;
    background-color: white;
    padding: 5px 25px 5px 25px;
  }
</style>
<script>
import DocumentByDate from '../charts/DocumentByDate'
import MapsByAffiliation from '../charts/MapsByAffiliation'
import FoamTreeSuggestionsBox from '../charts/FoamTreeSuggestionsBox'
import TopAffiliations from '../charts/TopAffiliations'
import { Carousel, Slide } from 'vue-carousel'
import FoamTreeSimpleSuggestionsBox from '../charts/FoamTreeSimpleSuggestionsBox'

export default {
  components: {
    FoamTreeSimpleSuggestionsBox,
    TopAffiliations,
    FoamTreeSuggestionsBox,
    MapsByAffiliation,
    DocumentByDate,
    Carousel,
    Slide
  },
  name: 'statsBox',
  props: ['searchState', 'pubDate', 'countries', 'listType', 'suggestions', 'biblio', 'companies', 'showLimitPlan'],
  watch: {
    boxOpen: function (val) {
      if (val === true && this.searchState === 2) {
        setTimeout(() => {
          this.draw()
        }, this.collapseSpeed)
      }
    },
    pubDate: function () {
      if (typeof this.$refs.documentByDate !== 'undefined' && this.boxOpen === true && this.searchState === 2) {
        setTimeout(() => {
          this.$refs.documentByDate.draw()
        }, this.collapseSpeed)
      }
    },
    suggestions: function () {
      if (typeof this.$refs.foam !== 'undefined' && this.boxOpen === true && this.searchState === 2) {
        setTimeout(() => {
          this.$refs.foam.draw()
        }, this.collapseSpeed)
      }
    },
    countries: function () {
      if (typeof this.$refs.geoMaps !== 'undefined' && this.boxOpen === true && this.searchState === 2) {
        setTimeout(() => {
          this.$refs.geoMaps.draw()
        }, this.collapseSpeed)
      }
    },
    companies: function () {
      if (typeof this.$refs.topAffiliations !== 'undefined' && this.boxOpen === true && this.searchState === 2) {
        setTimeout(() => {
          this.$refs.topAffiliations.draw()
        }, this.collapseSpeed)
      }
    },
    searchState: function (value) {
      if (value === 2 && this.boxOpen === true) {
        setTimeout(this.draw, this.collapseSpeed)
      }
    }
  },
  data () {
    return {
      isFullScreen: false,
      boxOpen: true,
      collapseSpeed: 300
    }
  },
  methods: {
    fullScreen: function (e) {
      let geo = $('#geoLocation')
      let iconFullScreen = $('#iconFullScreen')
      if (geo.hasClass('fullScreen')) {
        geo.removeClass('fullScreen')
        $('body').css('overflow', 'initial')
        this.isFullScreen = false
        $('#geoLocation').find('.panel-body').height('430px')
      } else {
        geo.addClass('fullScreen')
        $('body').css('overflow', 'hidden')
        this.isFullScreen = true
        $('#geoLocation').find('.panel-body').height((geo.height() * 94 / 100) + 'px')
      }
      this.$refs.geoMaps.diagramResize()
      e.preventDefault()
    },
    showHide: function (event) {
      if (event !== null) {
        event.preventDefault()
      }

      let hpanel = $(this.$el).closest('div.hpanel')
      let iconUp = $(this.$el).find('.fa-chevron-up')
      let iconDown = $(this.$el).find('.fa-chevron-down')
      let body = hpanel.find('div.panel-body:first')

      if (typeof iconUp !== 'undefined' && iconUp.length !== 0) {
        iconUp.toggleClass('fa-chevron-down').toggleClass('fa-chevron-up')
        this.boxOpen = false
      } else if (typeof iconDown !== 'undefined' && iconDown.length !== 0) {
        iconDown.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down')
        this.boxOpen = true
      }

      body.slideToggle(this.collapseSpeed)
      hpanel.toggleClass('').toggleClass('panel-collapse')

      localStorage.setItem('statsBoxOpen', this.boxOpen)
    },
    draw: function () {
      if (typeof this.$refs.foam !== 'undefined') {
        this.$refs.foam.draw()
      }
      if (typeof this.$refs.documentByDate !== 'undefined') {
        this.$refs.documentByDate.draw()
      }
      if (typeof this.$refs.geoMaps !== 'undefined') {
        this.$refs.geoMaps.draw()
      }
      if (typeof this.$refs.topAffiliations !== 'undefined') {
        this.$refs.topAffiliations.draw()
      }
    }
  },
  beforeMount () {
    let boxOpen = localStorage.getItem('statsBoxOpen')

    this.boxOpen = (boxOpen === null ? true : boxOpen === 'true')
  },
  mounted () {
    if (this.boxOpen === false) {
      this.showHide(null)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/StatsBox.vue